export default "__VITE_ASSET__QmfgnNIj__"